import React, { useEffect, useRef, useState } from "react";

import { Checkbox, Grid } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import DeleteModal from "../../../components/Common/DeleteModal.js";
import Label from "../../../components/Common/Label";
import LoadingDialog from "../../../components/Common/LoadingDialog";
import Notification from "../../../components/Common/Notification";
import SearchBar from "../../../components/Common/Searchbar";
import Table from "../../../components/Common/Table";
import TablePageControl from "../../../components/Common/TablePageControl";
import CustomButton from "../../../components/Form/CustomButton";
import CustomIconButton from "../../../components/Form/CustomIconButton";
import CustomSelect2 from "../../../components/Form/CustomSelect2";
import RenderPopOverButton from "../../../components/Form/RenderPopOverButton.js";
import Helpers from "../../../helpers/helpers";
import { bulkDeleteSchools, deleteSchools, exportSchools, getGeneral, getSchoolsListing, resetSchoolsAttachmentState, resetSchoolsState } from "../../../store/actions";
import "../setting.css";


const School = ({ schoolsListing, exportSchoolsDocument, userPermission, deleteSchoolsItem, bulkDelete }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const [loading, setIsLoading] = useState(false);
    const [filterStatus, setFilterStatus] = useState("all");
    const [selectedRow, setSelectedRow] = useState([]);
    const [checkedAll, setCheckedAll] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [keyword, setSearch] = useState("");
    const [sort, setSorted] = useState("asc")
    const [sort_by, setSortBy] = useState("id")
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    useEffect(() => {
        dispatch(resetSchoolsState());
    }, []);
    const [creatable, setCreatable] = useState(false);
    const [editable, setEditable] = useState(false);
    const [deletable, setDeletable] = useState(false);
    const [exportable, setExportable] = useState(false);
    const searchRef = useRef(keyword);

    const statusListing = [
        { label: "All statuses", value: "all" },
        { label: "Active", value: "1" },
        { label: "Inactive", value: "0" },
    ]

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-setting") && setCreatable(true);
            userPermission?.includes("edit-setting") && setEditable(true);
            userPermission?.includes("delete-setting") && setDeletable(true);
            userPermission?.includes("export-setting") && setExportable(true);
            !userPermission?.includes("view-setting") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        searchRef.current = keyword;
    }, [keyword]);

    useEffect(() => {
        initData();
    }, [page, length, sort, filterStatus, sort_by])

    useEffect(() => {
        if (deleteSchoolsItem?.code === "success") {
            setIsLoading(false);
            setNotification({ open: true, msg: "School deleted successfully", type: "success" });
            dispatch(resetSchoolsState());
            setDeleteOpen(false)
            dispatch(getGeneral());
            setPage('1');
            initData();
        }
        setIsLoading(false);
    }, [deleteSchoolsItem])

    useEffect(() => {
        if (exportSchoolsDocument?.code === 'success' && exportSchoolsDocument?.excel_base64) {
            Helpers.handleDownloadExcelFile(exportSchoolsDocument.excel_base64, 'schools_listing');
            dispatch(resetSchoolsAttachmentState());
        }
        setIsLoading(false);
    }, [exportSchoolsDocument])

    useEffect(() => {
        if (bulkDelete?.code === "success") {
            setIsLoading(false);
            setDeleteOpen(false);
            setNotification({
                open: true,
                msg: "Delete Successfully",
                type: "success",
            })
            dispatch(resetSchoolsState())
            setCheckedAll(false);
            dispatch(getGeneral());
            initData()
        } else if (bulkDelete?.code === "invalid_category") {
            setIsLoading(false);
            setDeleteOpen(false);
            setNotification({
                open: true,
                msg: "Invalid category",
                type: "error",
            })
            dispatch(resetSchoolsState())
            initData()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bulkDelete]);

    useEffect(() => {
        if (checkedAll && schoolsListing?.data) {
            const productListingIDs = schoolsListing.data.map((item) => item.id);
            setSelectedRow(productListingIDs);
        } else if (!checkedAll && selectedRow.length === schoolsListing?.data?.length) {
            // Only clear if all items were selected (meaning user clicked "uncheck all" header)
            setSelectedRow([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkedAll, schoolsListing?.data]);

    const handleCheckboxChange = (e) => {
        setCheckedAll(false)
        let temp = []
        if (selectedRow && selectedRow?.length > 0 && selectedRow.includes(parseInt(e))) {
            temp = selectedRow.filter((x) => x !== parseInt(e)).map((y) => y)
            setSelectedRow(temp)
        } else {
            setSelectedRow([...selectedRow, parseInt(e)])
        }
    }

    const header = [
        {
            Header: "#",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <Checkbox
                            checked={checkedAll ? checkedAll : selectedRow?.length > 0 ? selectedRow.includes(cellProps.id) : false}
                            sx={{
                                color: '#D0D0D0',
                                '&.Mui-checked': {
                                    color: "var(--bs-theme-color)",
                                },
                                paddingBlock: 0
                            }}
                            value={cellProps.id}
                            onChange={(event) => handleCheckboxChange(event.target.value, cellProps)} />
                    </React.Fragment>
                )
            },
        },
        {
            Header: "School Name",
            columnID: "name",
            accessor: (cellProps) => {
                return (cellProps?.name || "-")
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Active Contracts",
            columnID: "active_contract_count",
            accessor: (cellProps) => {
                return (cellProps?.active_contract_count)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Status",
            columnID: "status",
            accessor: (cellProps) => {
                return (<React.Fragment><Label.StatusLabel marginLeft={"0px"} label={cellProps?.status === 1 ? 'active' : 'inactive'} /></React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Action",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        {editable && <Link to={`/settings-edit-school/` + (cellProps.id)}>
                            <CustomIconButton iconName={'ri-pencil-line'} onClick={() => ''} />
                        </Link>}
                        <RenderPopOverButton
                            items={[{
                                iconName: 'ri-delete-bin-line',
                                label: 'Delete',
                                color: '#ED1A3D',
                                permission: deletable,
                                onClick: () => { setSelectedRow(cellProps); setDeleteOpen(true) }
                            }]}
                        />
                    </React.Fragment>
                )
            },
            position: 'sticky',
            disableFilters: true,
            filterable: false,
            minWidth: 120
        }
    ]

    const initData = () => {
        let payload = {
            paginate: page,
            sort_order: sort,
            sort_by: sort_by,
            size: length,
            search: searchRef.current,
            filterStatus: filterStatus === 'all' ? '' : filterStatus,
            sort: sort_by,
        }
        dispatch(getSchoolsListing(payload))
    }

    const handleExport = () => {
        let filter = {
            status: filterStatus,
            search: keyword
        }
        Object.keys(filter).forEach(key => {
            if (!filter[key] || filter[key] === 'all') {
                delete filter[key];
            }
        });
        setIsLoading(true);
        dispatch(exportSchools({
            sort: sort_by,
            sort_order: sort,
            filter: filter
        }));
    }

    const handleDelete = () => {
        setIsLoading(true);
        if (selectedRow?.length > 0) {
            dispatch(bulkDeleteSchools({ ids: selectedRow }))

        } else {
            dispatch(deleteSchools({ id: selectedRow.id }));
        }

    }

    const resetFilter = () => {
        setPage("1");
        setSearch('');
        setFilterStatus(filterStatus === '' ? 'all' : '');
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setPage("1");
                initData();
            }
        }, Helpers.searchInterval);
    }

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item xs={12} sm={10} spacing={1} className="d-flex align-items-center">
                    <Grid item lg={3} md={3} sm={4} xs={12}>
                        <SearchBar
                            value={keyword}
                            setValue={(e) => handleSearch(e)}
                        />
                    </Grid>
                    <Grid item lg={9} md={6} sm={8} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>
                {deletable && selectedRow && selectedRow?.length > 0 &&
                    <Grid item xs={12} sm={2} sx={{ display: 'flex', justifyContent: 'end' }} alignItems={'center'}>
                        <CustomButton
                            title={<><i className="ri-delete-bin-line" style={{ marginRight: 5 }} />Delete</>}
                            press={() => setDeleteOpen(true)}
                            height={32}
                            borderRadius={15}
                            textColor={"white"}
                            backgroundColor={"#ED1A3D"}
                            borderStyle={"1px solid #ED1A3D"}
                        /></Grid>}
                {/* {exportable && <Grid item xs={12} sm={2} md={2} lg={2} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }} alignItems={'center'}>
                    <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />
                </Grid>} */}
            </Grid>
        )
    }
    return (
        <React.Fragment>
            <div className="page-content">
                <LoadingDialog open={loading || !schoolsListing?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumb
                        title="Schools"
                        backRoute={'/settings'}
                        breadcrumbItems={[{ title: "Settings", link: "/settings" },
                        { title: "Schools", link: "#" },
                        ]}
                    >
                        {creatable && <CustomButton
                            title={<><i className="ri-add-line" style={{ marginRight: '5px' }} /> Add School</>}
                            press={() => navigate("/settings-add-school")}
                            height={40}
                            backgroundColor={'#101010'}
                            textColor={'white'}
                        />}
                    </Breadcrumb>
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={schoolsListing?.data || []}
                        pageSize={length}
                        totalPage={schoolsListing?.data?.last_page || 1}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                        setCheckedAll={setCheckedAll}
                        checkedAll={checkedAll}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={schoolsListing?.last_page || 1}
                    />
                </Container>
            </div>
            <DeleteModal
                open={deleteOpen}
                close={() => {setDeleteOpen(false); setSelectedRow([]); setIsLoading(false); setCheckedAll(false);}}
                submit={() => handleDelete()}
                module={'school'}
            />
        </React.Fragment >
    );
};

function mapStateToProps({ Schools, Login }) {
    return {
        schoolsListing: Schools?.schoolsListing,
        exportSchoolsDocument: Schools?.exportSchools,
        userPermission: Login?.permissionArry,
        deleteSchoolsItem: Schools?.deleteSchools,
        bulkDelete: Schools?.bulkDeleteSchools,
    };
}

export default connect(mapStateToProps)(School);
